import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const TickIcon = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg viewBox="0 0 20 15" {...props} ref={ref}>
          <path d="M1 7.75L6.5 13.25L18.75 1" stroke="currentcolor" />
        </svg>
      </Icon>
    );
  },
);

TickIcon.displayName = "TickIcon";
